// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"App_loaderContainer__cyIqk","loader":"App_loader__2fptQ"};